import { PATH } from '#const/path';
import { useDashboard } from '#providers/Dashboard';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

interface MemberLinkProps {
  personId: string;
  id: string;
  children?: React.ReactNode;
}

const MemberLink = ({ children, personId, id }: MemberLinkProps) => {
  const navigate = useNavigate();

  const { setConfirmationFormIdProps } = useDashboard();

  const onClick = () => {
    sessionStorage.setItem('personId', personId);
    sessionStorage.setItem('id', id);
    setConfirmationFormIdProps({ personId, id });
    navigate(`${PATH.DASHBOARD_CUSTOMER}`);
  };

  return (
    <Container onClick={onClick}>
      {children}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6665 13.3333L9.33315 12L13.3332 8.00001L9.33315 4.00001L10.6665 2.66668L15.9998 8.00001L10.6665 13.3333Z"
          fill="#948F9E"
        />
      </svg>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--BG-bg-500, #373245);
  cursor: pointer;
`;

export default MemberLink;
